import React, { useState } from 'react';
import OverviewListHeader from '~/components/molecule/OverviewListHeader';
import JustificationContainer from '~/components/atom/JustificationContainer';
import Button from '~/components/atom/Button';
import { navigate } from '@gatsbyjs/reach-router';
import TEST_ID from './index.testid';
import { LINK_PREFIX } from '../../../Wizard';
import Dropdown from '~/components/molecule/Dropdown';
import { actionOptions, type ActionType } from './constants';
import ActionModal from './components/ActionModal';
import useTrackEvent from '~/hooks/useTrackEvent';
import type { SelectedFlow } from '../FlowListTable';

const text = {
  title: 'Automation',
  addFlowLabel: 'Nieuwe flow',
  importFlowLabel: 'Flow importeren',
};

type Props = {
  selectedItems: Array<SelectedFlow>;
  deselectAllItems: () => void;
  onSuccessfulDelete: (flowId: string) => void;
  onSuccessfulEnabledChange: (flowId: string, newStatus: boolean) => void;
};

const FlowListToolbar: React.FCC<Props> = ({
  selectedItems,
  deselectAllItems,
  onSuccessfulDelete,
  onSuccessfulEnabledChange,
}) => {
  const [actionType, setActionType] = useState<ActionType | null>(null);
  const trackEvent = useTrackEvent();
  const selectedFlowIds = selectedItems.map(({ flowId }) => flowId);

  return (
    <>
      {actionType && (
        <ActionModal
          selectedItems={selectedItems}
          actionType={actionType}
          onClose={(hasUpdates: boolean) => {
            if (hasUpdates) {
              deselectAllItems();
              if (actionType === 'delete') {
                selectedFlowIds.forEach(onSuccessfulDelete);
                /** ----- TRACKING: flows_deleted ----- */
                trackEvent({
                  eventName: 'flows_deleted',
                  parameters: {
                    flows_amount: selectedItems.length,
                  },
                });
              }

              if (actionType === 'activate' || actionType === 'deactivate') {
                selectedFlowIds.forEach(flowId =>
                  onSuccessfulEnabledChange(flowId, actionType === 'activate'),
                );
              }
            }
            setActionType(null);
          }}
        />
      )}
      <JustificationContainer
        align="start"
        justification="start"
        direction="column"
        width="100%"
      >
        <OverviewListHeader
          title={text.title}
          buttons={[
            {
              key: 'overview-header-add-flow-button',
              node: (
                <Button
                  size="medium"
                  label={text.addFlowLabel}
                  icon="plus"
                  onClick={() => navigate(`${LINK_PREFIX}/v2/`)}
                  dataTestId={TEST_ID.OVERVIEW_HEADER}
                />
              ),
            },
            {
              key: 'overview-header-import-flow-button',
              node: (
                <Button
                  size="medium"
                  label={text.importFlowLabel}
                  icon="plus"
                  onClick={() => navigate('/-/automation/flows/import')}
                  dataTestId={TEST_ID.IMPORT_FLOW}
                  appearance="secondary"
                  ghost
                />
              ),
            },
          ]}
          extraButtons={[
            {
              key: 'flows-actions-dropdown',
              node: (
                <Dropdown
                  options={actionOptions}
                  onChange={({ option: { payload } }) => {
                    setActionType(payload);
                  }}
                  placeholder="Acties"
                  disabled={selectedItems.length === 0}
                />
              ),
            },
          ]}
        />
      </JustificationContainer>
    </>
  );
};

export default FlowListToolbar;
